import { DVACardType } from './DVACardType';

/* eslint-disable no-unused-vars */
export enum CoverType {
  MEDICARE = 'medicare',
  DVA = 'dva',
  MEDICARE_NOT_WITH_ME = 'medicare_not_with_me',
  NONE = 'none',
}
/* eslint-enable no-unused-vars */

export const COVER_LABELS: Record<CoverType, string> = {
  [CoverType.MEDICARE]: 'Medicare card',
  [CoverType.DVA]: 'DVA card',
  [CoverType.MEDICARE_NOT_WITH_ME]: 'Medicare card — not with me, to be provided before the appointment',
  [CoverType.NONE]: 'No Medicare or DVA card — private fee',
};

export interface IDVA {
  hasDept: boolean;
  cardType: DVACardType; // card colour
  cardNumber: string; // DVA file number
}

export interface MedicareCard {
  coverType: CoverType;
  // Only with a Medicare card in hand.
  medicareCardNumber?: string; // 3577664477
  medicareCardIRN?: string; // 1
  expiry?: string;
  // Only with a DVA card.
  dva?: IDVA;
}
